var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeadIndividual3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#6e0000;}.cls-10,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-9{fill-rule:evenodd;}.cls-4,.cls-8{fill:#900;}.cls-5{fill:#c79256;}.cls-6{fill:#a87841;}.cls-7{fill:#e8b274;}.cls-9{fill:#e6e6e6;}.cls-10{fill:#fff;}.cls-11{fill:#222c30;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 1,
    width: 145.5,
    height: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.44,142.13l45.64-.74L71.14,84l-45.93.75L25.75,118c.11,6.48-4.91,12.18-11.39,12.28a12.18,12.18,0,0,0,12.08,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.31,140.22h0l-.25-25.44C47.22,115,25.25,94.24,25,68.3a46.77,46.77,0,1,1,93.54-.93l.16,15.68-45.94.46.56,56.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119,140.47l-45.65.46-.57-57.42,45.94-.46.33,33.23c.06,6.48,5.23,12.05,11.71,12A12.17,12.17,0,0,1,119,140.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.49,75.28A7.83,7.83,0,1,0,118.4,83a7.81,7.81,0,0,0-7.91-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.53,79.19a3.92,3.92,0,1,0,4,3.88,3.92,3.92,0,0,0-4-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.24,76.06a7.83,7.83,0,1,0,7.9,7.75,7.83,7.83,0,0,0-7.9-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.28,80a3.92,3.92,0,1,0,3.95,3.87A3.92,3.92,0,0,0,32.28,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110,74.52l.28,28.15a38.76,38.76,0,1,1-77.52.78L32.4,68.18c8.54-7.49,15.32-19.43,15.22-31.73A38.82,38.82,0,0,0,87,74.75l23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M41.37,71.83A2.43,2.43,0,0,1,42.18,69a15.88,15.88,0,0,1,9.52-2.88,17.54,17.54,0,0,1,10,3A1.93,1.93,0,0,1,62,71.94h0a2,2,0,0,1-2.58.32,13.77,13.77,0,0,0-15.37.15,2,2,0,0,1-2.58-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.66,90.89a3.92,3.92,0,1,1-3.87,4,3.91,3.91,0,0,1,3.87-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M28.48,91.75a3.91,3.91,0,1,1-3.87,4,3.91,3.91,0,0,1,3.87-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M47.67,86.65a1.77,1.77,0,0,1-2-2.93,12.42,12.42,0,0,1,13.73-.18,1.77,1.77,0,0,1-1.92,3,8.86,8.86,0,0,0-9.82.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M87,86.14a1.77,1.77,0,0,1-2-2.93A12.4,12.4,0,0,1,98.75,83a1.77,1.77,0,1,1-1.91,3,8.86,8.86,0,0,0-9.82.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77,97.84l-.08-8.7a2.17,2.17,0,1,0-4.33,0h0l.06,6.52-2.19,0a6.53,6.53,0,1,0,.12,13.06l4.35,0a2.17,2.17,0,0,0,2.15-2.18Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeadIndividual3);
export default __webpack_public_path__ + "static/media/character-head-individual-3.fbf35016e8b41cc87062097ae5c6e449.svg";
export { ForwardRef as ReactComponent };